// extracted by mini-css-extract-plugin
module.exports = {"form":"ProtocolArea_form__OEWAl","formGroup":"ProtocolArea_formGroup__BfDj_","errorMessage":"ProtocolArea_errorMessage__Dbo3t","btnAction":"ProtocolArea_btnAction__44wVM"};